// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2tL6U","sendOtp":"AuthorizeToLogin_sendOtp__2OFpQ"};